import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, materialize, dematerialize, catchError } from 'rxjs/operators';
import { SxErrorService } from '@services';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private errorService: SxErrorService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return of(null).pipe(
      mergeMap(() => {
        return next.handle(request);
      }),
      materialize(),
      delay(0),
      dematerialize(),
      catchError(error => {
        this.errorService.handleError(error);
        return throwError(error);
      })
    );
  }
}

export let httpErrorInterceptor = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpErrorInterceptor,
  multi: true
};
